module.exports = __webpack_public_path__ + "static/media/thoriacImage3@3x.f1952280.png";